import * as CONST from "./actionTypes";

export const customerList = (payload, callBack) => {
  return {
    type: CONST.CUSTOMERS_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const customerList_Success = (payload) => ({
  type: CONST.CUSTOMERS_LIST_SUCCESS,
  payload,
});

export const customerList_Fail = (payload) => ({
  type: CONST.CUSTOMERS_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/
export const editCustomer = (payload, callBack) => {
  return {
    type: CONST.EDIT_CUSTOMER,
    payload: payload,
    callBack,
  };
};

export const editCustomer_Success = (payload) => ({
  type: CONST.EDIT_CUSTOMER_SUCCESS,
  payload,
});

export const editCustomer_Fail = (payload) => ({
  type: CONST.EDIT_CUSTOMER_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> UPDATE USER >>>>>>>>>>>>>>>*/

export const updateUser = (payload, callBack) => {
  return {
    type: CONST.UPDATE_USER,
    payload: { ...payload },
    callBack,
  };
};

export const updateUser_Success = (payload) => ({
  type: CONST.UPDATE_USER_SUCCESS,
  payload,
});

export const updateUser_Fail = (payload) => ({
  type: CONST.UPDATE_USER_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD USER >>>>>>>>>>>>>>>*/

export const addUser = (payload, callBack) => {
  return {
    type: CONST.ADD_USER,
    payload: { ...payload },
    callBack,
  };
};

export const addUser_Success = (payload) => ({
  type: CONST.ADD_USER_SUCCESS,
  payload,
});

export const addUser_Fail = (payload) => ({
  type: CONST.ADD_USER_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> BLOCK_UNBLOCK USER >>>>>>>>>>>>>>>*/

export const blockUnblockUser = (payload, callBack) => {
  return {
    type: CONST.BLOCK_UNBLOCK_USER,
    payload: { ...payload },
    callBack,
  };
};

export const blockUnblockUser_Success = (payload) => ({
  type: CONST.BLOCK_UNBLOCK_USER_SUCCESS,
  payload,
});

export const blockUnblockUser_Fail = (payload) => ({
  type: CONST.BLOCK_UNBLOCK_USER_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/

export const deleteUser = (payload, callBack) => {
  return {
    type: CONST.DELETE_USER,
    payload: { ...payload },
    callBack,
  };
};

export const deleteUser_Success = (payload) => ({
  type: CONST.DELETE_USER_SUCCESS,
  payload,
});

export const deleteUser_Fail = (payload) => ({
  type: CONST.DELETE_USER_FAIL,
  payload,
});

// SEND EMAIL //

export const sendEmail = (payload, callBack) => {
  return {
    type: CONST.SEND_EMAIL,
    payload: { ...payload },
    callBack,
  };
};

export const sendEmail_Success = (payload) => ({
  type: CONST.SEND_EMAIL_SUCCESS,
  payload,
});

export const sendEmail_Fail = (payload) => ({
  type: CONST.SEND_EMAIL_FAIL,
  payload,
});

// SEND TEXT //

export const sendText = (payload, callBack) => {
  return {
    type: CONST.SEND_TEXT,
    payload: { ...payload },
    callBack,
  };
};

export const sendText_Success = (payload) => ({
  type: CONST.SEND_TEXT_SUCCESS,
  payload,
});

export const sendText_Fail = (payload) => ({
  type: CONST.SEND_TEXT_FAIL,
  payload,
});

// POST DOCUMENT FILE //

export const postDocumentFile = (payload, callBack) => {
  return {
    type: CONST.POST_DOCUMENT_FILE,
    payload: { ...payload },
    callBack,
  };
};

export const postDocumentFile_Success = (payload) => ({
  type: CONST.POST_DOCUMENT_FILE_SUCCESS,
  payload,
});

export const postDocumentFile_Fail = (payload) => ({
  type: CONST.POST_DOCUMENT_FILE_FAIL,
  payload,
});

// DELETE USER DOCUMENT //

export const deleteUserDocument = (payload, callBack) => {
  return {
    type: CONST.DELETE_USER_DOCUMENT,
    payload: payload,
    callBack,
  };
};

export const deleteUserDocument_Success = (payload) => ({
  type: CONST.DELETE_USER_DOCUMENT_SUCCESS,
  payload,
});

export const deleteUserDocument_Fail = (payload) => ({
  type: CONST.DELETE_USER_DOCUMENT_FAIL,
  payload,
});

// update docuemnt file //

export const updateDocumentFile = (payload, callBack) => {
  return {
    type: CONST.UPDATE_DOCUMENT_FILE,
    payload: { ...payload },
    callBack,
  };
};

export const updateDocumentFile_Success = (payload) => ({
  type: CONST.UPDATE_DOCUMENT_FILE_SUCCESS,
  payload,
});

export const updateDocumentFile_Fail = (payload) => ({
  type: CONST.UPDATE_DOCUMENT_FILE_FAIL,
  payload,
});

// GET docuemnt file //

export const getDocumentFile = (payload, callBack) => {
  return {
    type: CONST.GET_DOCUMENT_FILE,
    payload: payload,
    callBack,
  };
};

export const getDocumentFile_Success = (payload) => ({
  type: CONST.GET_DOCUMENT_FILE_SUCCESS,
  payload,
});

export const getDocumentFile_Fail = (payload) => ({
  type: CONST.GET_DOCUMENT_FILE_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ACCEPT REJECT DOCUMENT >>>>>>>>>>>>>>>*/

export const acceptRejectDocument = (payload, callBack) => {
  return {
    type: CONST.ACCEPT_REJECT_DOCUMENT,
    payload: { ...payload },
    callBack,
  };
};

export const acceptRejectDocument_Success = (payload) => ({
  type: CONST.ACCEPT_REJECT_DOCUMENT_SUCCESS,
  payload,
});

export const acceptRejectDocument_Fail = (payload) => ({
  type: CONST.ACCEPT_REJECT_DOCUMENT_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> SEND DOCUMENT LIST >>>>>>>>>>>>>>>*/

export const sendDocumentList = (payload, callBack) => {
  return {
    type: CONST.SEND_DOCUMENTS_LIST,
    payload: payload,
    callBack,
  };
};

export const sendDocumentList_Success = (payload) => ({
  type: CONST.SEND_DOCUMENTS_LIST_SUCCESS,
  payload,
});

export const sendDocumentList_Fail = (payload) => ({
  type: CONST.SEND_DOCUMENTS_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> CHANGE PASSWORD >>>>>>>>>>>>>>>*/

export const resetUserPass = (payload, callBack) => {
  return {
    type: CONST.RESET_USER_PASS,
    payload: payload,
    callBack,
  };
};

export const resetUserPass_Success = (payload) => ({
  type: CONST.RESET_USER_PASS_SUCCESS,
  payload,
});

export const resetUserPass_Fail = (payload) => ({
  type: CONST.RESET_USER_PASS_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD NOTE >>>>>>>>>>>>>>>*/

export const addNote = (payload, callBack) => {
  return {
    type: CONST.ADD_NOTE,
    payload: payload,
    callBack,
  };
};

export const addNote_Success = (payload) => ({
  type: CONST.ADD_NOTE_SUCCESS,
  payload,
});

export const addNote_Fail = (payload) => ({
  type: CONST.ADD_NOTE_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> get note >>>>>>>>>>>>>>>*/

export const getNoteById = (payload, callBack) => {
  return {
    type: CONST.GET_NOTE_BY_ID,
    payload: payload,
    callBack,
  };
};

export const getNoteById_Success = (payload) => ({
  type: CONST.GET_NOTE_BY_ID_SUCCESS,
  payload,
});

export const getNoteById_Fail = (payload) => ({
  type: CONST.GET_NOTE_BY_ID_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> update note >>>>>>>>>>>>>>>*/

export const updateNote = (payload, callBack) => {
  return {
    type: CONST.UPDATE_NOTE,
    payload: payload,
    callBack,
  };
};

export const updateNote_Success = (payload) => ({
  type: CONST.UPDATE_NOTE_SUCCESS,
  payload,
});

export const updateNote_Fail = (payload) => ({
  type: CONST.UPDATE_NOTE_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> SINGLE NOTE >>>>>>>>>>>>>>>*/

export const getSingleNote = (payload, callBack) => {
  return {
    type: CONST.GET_SINGLE_NOTE,
    payload: payload,
    callBack,
  };
};

export const getSingleNote_Success = (payload) => ({
  type: CONST.GET_SINGLE_NOTE_SUCCESS,
  payload,
});

export const getSingleNote_Fail = (payload) => ({
  type: CONST.GET_SINGLE_NOTE_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DELETE NOTE >>>>>>>>>>>>>>>*/

export const deleteNote = (payload, callBack) => {
  return {
    type: CONST.DELETE_NOTE,
    payload: payload,
    callBack,
  };
};

export const deleteNote_Success = (payload) => ({
  type: CONST.DELETE_NOTE_SUCCESS,
  payload: payload,
});

export const deleteNote_Fail = (payload) => ({
  type: CONST.DELETE_NOTE_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> SMS HISTORY >>>>>>>>>>>>>>>*/

export const smsHistory = (payload, callBack) => {
  return {
    type: CONST.SMS_HISTORY,
    payload: payload,
    callBack,
  };
};

export const smsHistory_Success = (payload) => ({
  type: CONST.SMS_HISTORY_SUCCESS,
  payload: payload,
});

export const smsHistory_Fail = (payload) => ({
  type: CONST.SMS_HISTORY_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD EMAIL DRAFT >>>>>>>>>>>>>>>*/

export const addEmailDraft = (payload, callBack) => {
  return {
    type: CONST.ADD_EMAIL_DRAFT,
    payload: payload,
    callBack,
  };
};

export const addEmailDraft_Success = (payload) => ({
  type: CONST.ADD_EMAIL_DRAFT_SUCCESS,
  payload: payload,
});

export const addEmailDraft_Fail = (payload) => ({
  type: CONST.ADD_EMAIL_DRAFT_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DRAFT email list >>>>>>>>>>>>>>>*/

export const draftEmailList = (payload, callBack) => {
  return {
    type: CONST.DRAFT_EMAIL_LIST,
    payload: payload,
    callBack,
  };
};

export const draftEmailList_Success = (payload) => ({
  type: CONST.DRAFT_EMAIL_LIST_SUCCESS,
  payload: payload,
});

export const draftEmailList_Fail = (payload) => ({
  type: CONST.DRAFT_EMAIL_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DRAFT email by id >>>>>>>>>>>>>>>*/

export const draftEmailById = (payload, callBack) => {
  return {
    type: CONST.DRAFT_EMAIL_BY_ID,
    payload: payload,
    callBack,
  };
};

export const draftEmailById_Success = (payload) => ({
  type: CONST.DRAFT_EMAIL_BY_ID_SUCCESS,
  payload: payload,
});

export const draftEmailById_Fail = (payload) => ({
  type: CONST.DRAFT_EMAIL_BY_ID_FAIL,
  payload,
});
